
"use client"
// 
import localFont from "next/font/local";
import "./globals.css";

import Image from "next/image";
import logo from "./images/evans-energy-logo.png"
// import Link from "next/link";
import Head from 'next/head'
// import isBrowser from "./helpers/is_browser";

// eslint-disable-next-line
// import { useEffect } from "react";
import { Transition } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/24/outline'

import { globalErrorAtom } from "@/app/state"
import { useAtom } from "jotai";
// import OfflineBanner from "./components/offline_banner";


// eslint-disable-next-line
// import headers from "@/app/helpers/default_headers"
// import Fetch from "@/app/helpers/fetch_with_to"

import { ErrorBoundary } from "react-error-boundary";
import { XMarkIcon } from "@heroicons/react/20/solid";

// import FingerprintJS from '@fingerprintjs/fingerprintjs'

// let fpPromise

// if (isBrowser()) {
//   fpPromise = FingerprintJS.load()
// }


// const _fetch = Fetch(2500)
// const blacklistOfflineBanner = ['/login', '/invest']

const geistSans = localFont({
  src: "./fonts/GeistVF.woff",
  variable: "--font-geist-sans",
  weight: "100 900",
});
const geistMono = localFont({
  src: "./fonts/GeistMonoVF.woff",
  variable: "--font-geist-mono",
  weight: "100 900",
});


// eslint-disable-next-line
function fallbackRender({ error, resetErrorBoundary }) {
  // resetErrorBoundary()
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: "red" }}>{error.message}</pre>
    </div>
  );
}

export default function BareLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {

  const [globalError, setGlobalError] = useAtom(globalErrorAtom)


  // eslint-disable-next-line
  async function checkSWVersion() {
    const version = await serwist.messageSW({ type: 'GET_VERSION' })
    console.log("VERSION ", version)
  }

  // eslint-disable-next-line
  function isAdmin() {
    return wellAdmin || wellUser || fullAdmin
  }


  // const [width] = useWindowSize()


  return (
    <>
      <html lang="en">
        <Head>
          <title>Evans Energy II - Joint Venture Oil & Gas</title>
          <link rel="manifest" href="/manifest.json" />
          <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
        </Head>
        <body
          className={`${geistSans.variable} ${geistMono.variable} antialiased`}
        >
          <ErrorBoundary fallbackRender={fallbackRender} >
            <nav className="header border-gray-200">

              <div style={{ height: '100%' }}>
                <div className="flex" style={{ height: '100%' }}>
                  <div className="flex" style={{ maxWidth: '355px', height: '100%', padding: '0 1rem 0 1rem' }}>
                    <a href="/projects" className="flex items-center space-x-3 rtl:space-x-reverse no-underline">
                      <Image alt="Evans Energy Logo" src={logo} style={{ width: '175px' }} />
                    </a>
                  </div>
                </div>
              </div>
            </nav >

            {globalError === "" ? null : (
              <div
                aria-live="assertive"
                className="relative pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
              >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                  {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                  <Transition show={globalError !== ""}>
                    <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0">
                      <div className="p-4">
                        <div className="flex items-start">
                          <div className="flex-shrink-0">
                            <CheckCircleIcon aria-hidden="true" className="h-6 w-6 text-red-400" />
                          </div>
                          <div className="ml-3 w-0 flex-1 pt-0.5">
                            <p className="text-sm font-medium text-gray-900">{globalError}</p>
                            <p className="mt-1 text-sm text-gray-500"></p>
                          </div>
                          <div className="ml-4 flex flex-shrink-0">
                            <button
                              type="button"
                              onClick={() => {
                                setGlobalError("")
                              }}
                              className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-lime-950 focus:ring-offset-2"
                            >
                              <span className="sr-only">Close</span>
                              <XMarkIcon aria-hidden="true" className="h-5 w-5" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Transition>
                </div>
              </div>
            )}

            {/* <InstallPrompt /> */}
            {children}
          </ErrorBoundary>
        </body >
      </html >
    </>
  );
}
